// ============================================
// nav
// ============================================

function navBottom() {
	const navBottom = document.querySelector('.js-nav-bottom');
	if (navBottom) {
		window.addEventListener('scroll', function() {
			const hero = document.querySelector('.js-nav-bottom__hero');
			const heroHeight = hero.getBoundingClientRect().bottom;
			if(heroHeight < 0) {
				navBottom.classList.add('is-active');
				} else {
				navBottom.classList.remove('is-active');
			}
		})
	}
}

// ============================================
// エクスポート
// ============================================
export { navBottom };